import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMoneyPhone = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.6 13.8V19.8C12.6 20.1183 12.4736 20.4235 12.2485 20.6485C12.0235 20.8736 11.7183 21 11.4 21H4.2C3.88174 21 3.57652 20.8736 3.35147 20.6485C3.12643 20.4235 3 20.1183 3 19.8V5.4C3 5.08174 3.12643 4.77651 3.35147 4.55147C3.57652 4.32643 3.88174 4.2 4.2 4.2H9.6"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 17.4H12.6"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4 5.40001H15.7736C15.5238 5.39921 15.2816 5.4856 15.0887 5.64428C14.8958 5.80296 14.7643 6.02398 14.7169 6.26922C14.6695 6.51447 14.7091 6.76857 14.829 6.9877C14.9489 7.20684 15.1415 7.37727 15.3736 7.46961L17.024 8.13041C17.2552 8.22345 17.4469 8.39405 17.5661 8.61295C17.6853 8.83185 17.7246 9.08541 17.6773 9.33014C17.63 9.57486 17.4991 9.79551 17.3069 9.95422C17.1147 10.1129 16.8733 10.1998 16.624 10.2H15"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2 5.4V4.8"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2 10.8V10.2"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4 7.8C11.4 9.07304 11.9057 10.2939 12.8059 11.1941C13.7061 12.0943 14.927 12.6 16.2 12.6C17.4731 12.6 18.694 12.0943 19.5941 11.1941C20.4943 10.2939 21 9.07304 21 7.8C21 6.52696 20.4943 5.30606 19.5941 4.40589C18.694 3.50571 17.4731 3 16.2 3C14.927 3 13.7061 3.50571 12.8059 4.40589C11.9057 5.30606 11.4 6.52696 11.4 7.8V7.8Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMoneyPhone.displayName = 'SvgMoneyPhone';
export default SvgMoneyPhone;
